export default __webpack_public_path__ + "d929dfea1a313e2adb956e68645a0766.png";